<h1 mat-dialog-title fxLayoutAlign="center" class="mat-error">Error Purchasing Phone Numbers</h1>

<div mat-dialog-content>
  <p>There was an error purchasing phone numbers. {{ errorMsg }}</p>
</div>

<div mat-dialog-actions fxLayout="row" fxLayoutAlign="center center">
  <button mat-button [mat-dialog-close]="true" fxFlex="40%" [disabled]="!continueMsg">{{ continueMsg }}</button>
  <button mat-raised-button mat-dialog-close fxFlex="40%">{{ goBackMsg }}</button>
</div>
